import {connect} from 'react-redux';
import Next from './Next';
import {nextQuestion, clearSelection} from '../../../../actions/exam';

const mapStateToProps = state => ({
  mode: state.exam.mode,
  hasNextQuestion: state.exam.questions ? state.exam.currentQuestion < state.exam.questions.length - 1 : false
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  nextQuestion: () => {
    dispatch(nextQuestion());
    dispatch(clearSelection());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Next);
